import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import "bootstrap/dist/css/bootstrap.min.css";
import "react-image-timeline/dist/timeline.css";
import "./styles.css";

ReactDOM.render(<App />, document.getElementById("root"));
